import styled from "styled-components";

const EmployeeDirectorySc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .emp-table {
    width: 100vw;
  }
  .employee_directory_x_container {
    padding: 10px;
  }
  table {
    font-family: arial, sans-serif;
    width: 100%;
    margin: 30px auto;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }

  th {
    background-color: #4285f4;
    color: #fff;
    border: 1px solid #4285f4;
    text-align: center;
    padding: 12px;
  }

  .heading {
    text-align: center;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  th:hover {
    background-color: #3367d6;
  }

  tr:hover td {
    background-color: #e4f0fb;
  }
`;
export default EmployeeDirectorySc;
